module.exports = __webpack_public_path__ + "static/media/create distributor.f7ea189b.png";